/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Vehicle_Action_Archive_Description_RetiredInputs */

const fr_vehicle_action_archive_description_retired = /** @type {(inputs: Vehicle_Action_Archive_Description_RetiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`il est réformé (TC-Infos fait foi) ;`)
};

const en_vehicle_action_archive_description_retired = /** @type {(inputs: Vehicle_Action_Archive_Description_RetiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`it has been retired (TC-Infos is the source of truth);`)
};

/**
* | output |
* | --- |
* | "it has been retired (TC-Infos is the source of truth);" |
*
* @param {Vehicle_Action_Archive_Description_RetiredInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const vehicle_action_archive_description_retired = /** @type {((inputs?: Vehicle_Action_Archive_Description_RetiredInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vehicle_Action_Archive_Description_RetiredInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_vehicle_action_archive_description_retired(inputs)
	return en_vehicle_action_archive_description_retired(inputs)
});